import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CapitalOrName = (c, t) => {
  if (t === 'States') return c.name;
  if (t === 'Capitals') return c.capital;
  return null;
};

const Question = ({ current, qtype }) => (
  <div className={classNames('question', current.misses > 0 ? `error error__animate__${current.misses}` : '')}>
    {CapitalOrName(current, qtype)} <span>({current.misses} / 3)</span>
  </div>
);

Question.propTypes = {
  current: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    d: PropTypes.string.isRequired,
    capital: PropTypes.string.isRequired,
    misses: PropTypes.number,
  }).isRequired,
  qtype: PropTypes.string.isRequired,
};

export default Question;



// WEBPACK FOOTER //
// ./src/components/Question.js